import { Box, Link, Paper, Typography } from '@mui/material';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Text from '../../shared/Text';
import { FORGOT_PASSWORD_INDEX } from '../constants/routes';
import { LOGIN_SUPPORT_URL_INCYDR } from '../constants/urls';
import LogoIcon from './logo-icon/LogoIcon';
import { useAuthData } from './providers/auth/hooks';

export interface LoginWrapperProps {
  footer?: React.ReactNode;
  showForgotPasswordLink?: boolean;
  showSupportLink?: boolean;
}

const LoginWrapper: React.FC<LoginWrapperProps> = ({
  children,
  footer,
  showForgotPasswordLink,
  showSupportLink,
}) => {
  const { serverType } = useAuthData();
  const isStorageNode = serverType?.storage;

  return (
    <Box minWidth={430} mt="10%" mx="auto" width="min-content">
      <Paper elevation={1}>
        <Box pb={4} pt={5}>
          <Box textAlign="center">
            <LogoIcon />
          </Box>
          <div>{children}</div>
        </Box>
      </Paper>
      {footer ? (
        <Box my={2}>{footer}</Box>
      ) : (
        <Box display="flex" justifyContent="space-between" my={2}>
          {showSupportLink && (
            <Typography variant="caption">
              {Text.get('login_support_need_help')}&nbsp;
              <Link
                href={LOGIN_SUPPORT_URL_INCYDR}
                target="_blank"
                rel="noopener noreferrer"
                data-test="login-wrapper-support-link"
              >
                {Text.get('login_support_learn_more')}
              </Link>
            </Typography>
          )}
          {showForgotPasswordLink && !isStorageNode && (
            <Typography variant="caption">
              <Link component={RouterLink} data-test="forgot-pw-link" to={FORGOT_PASSWORD_INDEX}>
                {Text.get('login_forgot_password')}
              </Link>
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default LoginWrapper;
